import { Lazy } from '@betgames/bg-state-manager';
import { authDecorator } from 'decorators/AuthDecorator';
import { sessionStore } from 'store/Session';
import BalanceRepository from './Balance.repository';
import BalanceStore from './Balance.store';

export const balance = new Lazy(
    () => new BalanceStore(new BalanceRepository(authDecorator), sessionStore),
);
export { balanceSelectors } from './Balance.selectors';
